export class PeriodicEditionModel {
  constructor(
    public id: number,
    public editionNumber: string,
    public editionDate: string,
    public year: string
  ) {}
}
